var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as jsCookie from 'js-cookie';
export function setPetriOverrides(newValues) {
    var petriCookie = serializePertiCookie(newValues);
    var topDomain = location.hostname
        .split('.')
        .slice(-2)
        .join('.');
    jsCookie.set('petri_ovr', petriCookie, {
        domain: topDomain.includes('.') ? "." + topDomain : topDomain,
        expires: 7,
    });
}
export function getPetriOverrides() {
    var pertiCookie = jsCookie.get('petri_ovr');
    return parsePertiCookie(pertiCookie);
}
export function parsePertiCookie(pertiCookie) {
    if (pertiCookie === void 0) { pertiCookie = ''; }
    if (!pertiCookie) {
        return [];
    }
    return pertiCookie
        .split('|')
        .map(function (kvp) { return kvp.split('#'); })
        .map(function (_a) {
        var name = _a[0], value = _a[1];
        return ({ name: name, value: value });
    });
}
export function serializePertiCookie(newValues) {
    return newValues
        .filter(function (_a) {
        var value = _a.value;
        return Boolean(value);
    })
        .map(function (_a) {
        var name = _a.name, value = _a.value;
        return name + "#" + value;
    })
        .join('|');
}
export function toObject(overrides) {
    return overrides
        .filter(function (_a) {
        var value = _a.value;
        return Boolean(value);
    })
        .reduce(function (asObject, _a) {
        var _b;
        var value = _a.value, name = _a.name;
        return __assign(__assign({}, asObject), (_b = {}, _b[name] = value, _b));
    }, {});
}
//# sourceMappingURL=petri.js.map